import { ref } from 'vue'

// 全局APP下载弹窗状态
const showAppDownloadModal = ref(false)
const modalTitle = ref('下载猫星球APP')
const modalDescription = ref('扫描二维码下载猫星球APP，享受完整的猫星球体验')

export function useAppDownload() {
  const showQRModal = (title?: string, description?: string) => {
    if (title) modalTitle.value = title
    if (description) modalDescription.value = description
    showAppDownloadModal.value = true
  }

  const closeQRModal = () => {
    showAppDownloadModal.value = false
    // 重置为默认值
    modalTitle.value = '下载猫星球APP'
    modalDescription.value = '扫描二维码下载猫星球APP，享受完整的猫星球体验'
  }

  // 检查点击事件是否应该被拦截
  const shouldInterceptClick = (event: Event) => {
    const target = event.target as HTMLElement
    if (!target) return false

    // 允许的点击类型（不拦截）
    const allowedSelectors = [
      // 路由链接
      'a[href]',
      'router-link',
      '[data-router-link]',
      
      // 搜索相关
      'input[type="text"]',
      'input[type="search"]',
      '[data-search]',
      'form',
      
      // 下载相关
      '[data-download]',
      '.btn-download',
      
      // 导航相关
      '[data-nav]',
      '.sidebar',
      '.header',
      
      // 弹窗相关
      '.modal',
      '[data-modal]',
      
      // 已经有特殊处理的元素
      '[data-no-intercept]'
    ]

    // 检查目标元素或其父元素是否匹配允许的选择器
    let currentElement: HTMLElement | null = target
    while (currentElement) {
      for (const selector of allowedSelectors) {
        if (currentElement.matches && currentElement.matches(selector)) {
          return false
        }
      }
      currentElement = currentElement.parentElement
    }

    // 检查是否是按钮但不是普通的内容按钮
    if (target.tagName === 'BUTTON') {
      const buttonClasses = target.className
      // 如果是导航、搜索、下载相关的按钮，不拦截
      if (buttonClasses.includes('btn-secondary') || 
          buttonClasses.includes('btn-icon') ||
          buttonClasses.includes('search') ||
          buttonClasses.includes('nav') ||
          buttonClasses.includes('download')) {
        return false
      }
    }

    return true
  }

  const handleGlobalClick = (event: Event) => {
    if (shouldInterceptClick(event)) {
      event.preventDefault()
      event.stopPropagation()
      showQRModal('探索更多功能，下载猫星球APP', '完整的猫星球体验在APP中等您发现，立即下载享受更多精彩内容')
    }
  }

  return {
    showAppDownloadModal,
    modalTitle,
    modalDescription,
    showQRModal,
    closeQRModal,
    handleGlobalClick
  }
}
